import * as React from "react"
import { Skeleton } from "@mui/material";

import { WEBBACK_V2_API } from "@constants";
import { TitleWithPopover, AppTableSeeker } from "@components";
import { useToast } from "@hooks";
import { isLoadingCommonFilters } from "@signals";
import { reasonColumn, dateColumn, retailerColumn, skuColumn, priceColumn, buyboxSellerColumn, daysDeliveryColumn } from "./columns";
import { useMarketplacesLostBuyBoxTableData } from "./@hooks";
import CreateReportButton from "./actions/CreateReportButton";


export default function LostBuyBoxTable() {
	const { showToast } = useToast()
	const { tableData } = useMarketplacesLostBuyBoxTableData()

	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
	if (!tableData?.length) return <></>

	return <AppTableSeeker
		data={tableData}
		title={<TitleWithPopover title="Lost Buy Box" />}
		columns={[
			...retailerColumn(),
			dateColumn(),
			...skuColumn(),
			reasonColumn(),
			priceColumn('price1P','Price 1P'),
			priceColumn('shippingPrice1P', 'Shipping Price 1P'),
			...daysDeliveryColumn('deliveryDays', 'Days delivery'),
			buyboxSellerColumn(),
			priceColumn('priceBuybox','Price BuyBox'),
			priceColumn('shippingPriceBuybox', 'Shipping Price BuyBox'),
			...daysDeliveryColumn('deliveryDaysBuybox', 'Days delivery BuyBox'),
		]}
		options={{
			onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/marketplaces/lose-buy-box-details/excel`),
			customToolbar: () => <CreateReportButton />,
			enhancedSetRowProps: () => ({ sx: {
				"&:has(.is-open)": {backgroundColor: "primary.light"}
			} })
		}}
	/>
}